import { ArrowLeft, ShieldAlert } from 'lucide-react';
import { Link, useParams } from 'react-router';
import { EmptyState } from '../../../shared/components/EmptyState';
import { FormCardSkeleton } from '../../../shared/components/FormCardSkeleton';
import { ReceiveTruckContent } from '../components/ReceiveTruckContent';
import { useReceiveTruck } from '../hooks/use-receive-truck';
import { YARD_PATH } from '../yard.paths';

/** One returning truck: its readings and defects from the post-trip check, what is missing, and the one action that receives it. */
export function ReceiveTruckPage() {
  const { tripId = '' } = useParams();
  const receiving = useReceiveTruck(tripId);
  const { state, view } = receiving;

  // The route's errorElement shows the failure, so the page does not invent a second kind of error screen.
  if (state.status === 'error') throw state.error;

  return (
    <div className="flex flex-col gap-4">
      <Link to={YARD_PATH} className="inline-flex items-center gap-1.5 self-start py-2 text-sm">
        <ArrowLeft className="size-4" aria-hidden /> Trucks due back
      </Link>
      {state.status === 'loading' && <FormCardSkeleton label="Loading the truck" fields={2} />}
      {state.status === 'forbidden' && (
        <EmptyState
          icon={ShieldAlert}
          title="You can't receive trucks"
          description="Receiving trucks at the yard needs the yard supervisor's permission. Ask an administrator."
        />
      )}
      {view && <ReceiveTruckContent view={view} receiving={receiving} />}
    </div>
  );
}
